export default __webpack_public_path__ + "static/media/notFound.93a14929.png";